import React, { useState } from 'react';
import * as Yup from 'yup';
import { Modal, Tooltip } from 'antd';
import { Button, FormDatePicker, FormSubmitButton, MasterDetailForm, Widget } from '@digital/ui';
import { UploadFile, Visibility } from '@app/components';
import { ordemCompraIdState, reloadVendorListState, dataLimiteEtapaState } from '../atoms';
import { useRecoilState, useRecoilValue } from 'recoil';
import { ativarNegociacaoMinutaContratual } from '@app/api/sas/ordemCompra';

interface Props {

}

export const ButtonModalAtivarNegociacaoMinuta = (props: Props) => {
    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
    const dataLimiteEtapa = useRecoilValue(dataLimiteEtapaState);
    const [open, setOpen] = useState(false);

    const onCancel = () => {
        setReloadVendorList(!reloadVendorList);
        setOpen(false);
    };

    const onSubmit = (values: any) => {
        if (!values.arquivo) {
            Modal.error({ title: 'Arquivo obrigatório', content: 'Selecione o arquivo da minuta contratual antes de continuar.' });
            return;
        }
        Modal.confirm({
            title: 'Confirmar notificação da negociação de minuta',
            content: 'Notificar fornecedor da negociação da minuta?',
            cancelText: 'Cancelar',
            onCancel: () => { },
            okText: 'Confirmar',
            onOk: () => {
                Modal.confirm({
                    title: 'Confirmação Envio de Email',
                    content:
                        'Você deseja enviar e-mail de notificação aos fornecedores?',
                    cancelText: 'Não',
                    onCancel: () => {
                        ativarNegociacaoMinutaContratual(ordemCompraId, false, values.dataLimite, values.arquivo)
                            .then((response: any) => {
                                if (response && response.valid) {
                                    onCancel();
                                }
                            });
                    },
                    okText: 'Sim',
                    onOk: () => {
                        ativarNegociacaoMinutaContratual(ordemCompraId, true, values.dataLimite, values.arquivo)
                            .then((response: any) => {
                                if (response && response.valid) {
                                    onCancel();
                                }
                            });
                    },
                });
            },
        });
    };

    return (
        <>
            <Tooltip title="Negociação de Minuta Contratual">
                <Button onClick={() => setOpen(true)}>Notificar fornecedor da Negociação de Minuta</Button>
            </Tooltip>
            <Visibility visible={open}>
                <MasterDetailForm
                    key="formButtonModalAtivarNegociacaoMinuta"
                    onSubmit={onSubmit}
                    validationSchema={Yup.object().shape({
                        dataLimite: Yup.string().nullable().required('Data limite é obrigatória'),
                        arquivo: Yup.mixed().required('O arquivo da minuta contratual é obrigatório'),
                    })}
                >
                    <Modal
                        onCancel={onCancel}
                        title='Notificar fornecedor da Negociação de Minuta'
                        visible={open}
                        footer={[
                            <Button title='Fechar' onClick={onCancel} type="link" />,
                            <FormSubmitButton noIcon type="primary" title='Enviar' />
                        ]}
                    >
                        <Widget>
                            <FormDatePicker
                                label="Data Limite de Resposta"
                                name="dataLimite"
                                format="DD/MM/YYYY"
                                span={4}
                                disabledDate={function(current) {
                                    if (!dataLimiteEtapa) return false;
                                    var limite = new Date(dataLimiteEtapa);
                                    limite.setHours(23, 59, 59, 999);
                                    return current && current.toDate() > limite;
                                }}
                            />
                            <UploadFile
                                idDoComponente="uploadMinutaContratual"
                                nameFormData="arquivo"
                                label="Minuta Contratual (obrigatório)"
                                span={12}
                            />
                        </Widget>
                    </Modal>
                </MasterDetailForm>
            </Visibility>
        </>
    );
};
